import Link from 'next/link';
import { useRouter } from 'next/router';
import { memo, useEffect } from 'react';
import config from '../../../libs/config';
import styles from '../../../styles/components/section/common/Pagination.module.scss';
import ArrowX from '../../icon/ArrowX';

const Pagination = memo(({ totalCount, page, currentPageNum }) => {
    // const range = (start, end) =>
    //     [...Array(end - start + 1)].map((_, i) => start + i);
    const router = useRouter();
    const locationHrefNumber = router.query.page ?? '1';
    //総ページ数
    const currentPageNumber = Math.ceil(
        totalCount / config.STORY_PAGE_MAX_SIZE
    );

    const queryString = (number) =>
        router.query.category
            ? '?category=' + router.query.category + '&page=' + number
            : '?page=' + number;

    let pageNum;
    if (!router.query.page) {
        pageNum = 1;
    } else {
        pageNum = Number(router.query.page);
    }

    const paginationGenerator = (pageNum, currentPageNumber, width = 1) => {
        const left = pageNum - width;
        const right = pageNum + width + 1;
        const range = [];
        const rangeWithDots = [];
        let length;
        for (let i = 1; i <= currentPageNumber; i += 1) {
            if (
                i === 1 ||
                i === currentPageNumber ||
                (i >= left && i <= right)
            ) {
                range.push(i);
            } else if (i < left) {
                i = left - 1;
            } else if (i > right) {
                range.push(currentPageNumber);
                break;
            }
        }
        range.forEach((i) => {
            if (length) {
                if (i - length === 2) {
                    rangeWithDots.push(length + 1);
                } else if (i - length !== 1) {
                    rangeWithDots.push('...');
                }
            }
            rangeWithDots.push(i);
            length = i;
        });
        return rangeWithDots;
    };

    useEffect(() => {
        // hover
        const html = document.querySelector('html');
        const arrowLinks = document.querySelectorAll('.js-hover__pagination');
        const options = [];
        const eventHandler = {
            mouseEnter: null,
            mouseLeave: null,
        };
        const _defaultDuration = {
            in: 600,
            out: 600,
        };
        function _setFlag() {
            const length = arrowLinks.length;
            for (let i = length; i--; ) {
                options[i] = {
                    isHovering: false,
                    isAnimating: false,
                };
                let target = arrowLinks[i];
                target.setAttribute('data-hover-num', i);
            }
        }
        _setFlag();
        function _setEventListener() {
            eventHandler.mouseEnter = (e) => {
                e.preventDefault();
                _onMouseEnter(e.currentTarget);
            };
            eventHandler.mouseLeave = (e) => {
                e.preventDefault();
                _onMouseLeave(e.currentTarget);
            };
            [].forEach.call(arrowLinks, ($el) => {
                $el.addEventListener(
                    'mouseenter',
                    eventHandler.mouseEnter,
                    false
                );
                $el.addEventListener(
                    'mouseleave',
                    eventHandler.mouseLeave,
                    false
                );
            });
        }
        _setEventListener();
        function _onMouseEnter($this) {
            const num = Number($this.dataset['hoverNum']);
            options[num].isHovering = true;
            if (!options[num].isAnimating) {
                _startMouseEnter($this, num);
            }
        }
        function _onMouseLeave($this) {
            const num = Number($this.dataset[`hoverNum`]);
            options[num].isHovering = false;
            if (!options[num].isAnimating) {
                _startMouseLeave($this, num);
            }
        }
        function _startMouseEnter($this, num) {
            options[num].isAnimating = true;
            // if (!html.classList.contains('deviceMobile')) {
            $this.classList.add('is-hover');
            // }
            const time =
                Number($this.dataset['hoverInTime']) || _defaultDuration.in;
            setTimeout(() => {
                _completeMouseEnter($this, num);
            }, time);
        }
        function _startMouseLeave($this, num) {
            options[num].isAnimating = true;
            // if (!html.classList.contains('deviceMobile')) {
            $this.classList.remove('is-hover');
            $this.classList.add('is-hover-out');
            // }
            const time =
                Number($this.dataset['hoverOutTime']) || _defaultDuration.out;
            setTimeout(() => {
                _completeMouseLeave($this, num);
            }, time);
        }
        function _completeMouseEnter($this, num) {
            options[num].isAnimating = false;
            if (!options[num].isHovering) {
                _startMouseLeave($this, num);
            }
        }
        function _completeMouseLeave($this, num) {
            options[num].isAnimating = false;
            // if (!html.classList.contains('deviceMobile')) {
            $this.classList.remove('is-hover-out');
            // }
            if (options[num].isHovering) {
                _startMouseEnter($this, num);
            }
        }
    }, [router, pageNum, currentPageNumber]);

    return (
        <>
            {currentPageNumber > 1 && (
                <div className={styles.container}>
                    <div className={styles.wrapper}>
                        <Link href={`/${page}${queryString(pageNum - 1)}`}>
                            <a
                                className={`${styles.arrow} ${
                                    styles.prev
                                } paginationArrow js-hover__pagination ${
                                    Number(locationHrefNumber) === 1
                                        ? ''
                                        : 'is-show'
                                }`}
                            >
                                <ArrowX color="#0c3b2c" />
                            </a>
                        </Link>

                        <ul className={styles.list}>
                            {paginationGenerator(
                                pageNum,
                                currentPageNumber
                            ).map((number, index) => (
                                <li
                                    className={`${
                                        styles.item
                                    } js-hover__pagination
                            ${pageNum === number ? 'is-current' : ''}${
                                        number === '...'
                                            ? 'is-current__prevent'
                                            : ''
                                    }
                            `}
                                    key={index}
                                >
                                    <Link
                                        href={`/${page}${queryString(number)}`}
                                    >
                                        <a
                                            className={`${styles.itemLink} paginationLink js-hover__color__point`}
                                        >
                                            {number}
                                        </a>
                                    </Link>
                                </li>
                            ))}
                            {/* {range(
                                1,
                                Math.ceil(
                                    totalCount / config.STORY_PAGE_MAX_SIZE
                                )
                            ).map((number, index) => (
                                <li
                                    className={`${styles.item}
                            ${
                                // Number(number) === 1 ||
                                // Number(locationHrefNumber) === Number(number)
                                pageNum === number ? 'is-current' : ''
                            }
                            `}
                                    key={index}
                                >
                                    <Link
                                        href={`/${page}${queryString(number)}`}
                                    >
                                        <a
                                            className={`${styles.itemLink} paginationLink`}
                                        >
                                            {number}
                                        </a>
                                    </Link>
                                </li>
                            ))} */}
                        </ul>
                        <Link href={`/${page}${queryString(pageNum + 1)}`}>
                            <a
                                className={`${styles.arrow} ${
                                    styles.next
                                } paginationArrow js-hover__pagination ${
                                    Number(locationHrefNumber) ===
                                    Number(currentPageNumber)
                                        ? ''
                                        : 'is-show'
                                }`}
                            >
                                <ArrowX />
                            </a>
                        </Link>
                    </div>
                </div>
            )}
        </>
    );
});

Pagination.displayName = 'Pagination';

export default Pagination;
